import React, { Component } from 'react';
import { connect } from 'react-redux';

import { message } from 'antd';
import { browserHistory } from 'react-router';
import { querySaveCustom } from '@api/crm/crm';
import FormProduct from './FormProduct';

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = { data: {} };
  }

  handleAdd = params => {
    querySaveCustom(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ data: nextProps.data });
  }

  render() {
    const { data } = this.state;

    return (
      <div>
        <FormProduct
          ref={form => {
            this.form = form;
          }}
          handleSubmit={this.handleAdd}
          data={data}
        />
      </div>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(BaseForm);



// WEBPACK FOOTER //
// ./src/components/client/product/PageAdd.js